import { fetchCategoryChartVisibility } from "../categoryChart";
import { GET_CATEGORY_CHART_BY_CATEGORY_ID_PARAMS } from "../graphql";
import { EMPTY_ARRAY, queryEntities } from "../misc";
import { CategoryChart, CategoryChartEntity } from "../processors";
import * as processors from "../processors";
import { CategoryTemplateController } from "./types";
import _ from "lodash";
import { FetchPolicy } from "@apollo/client";

export const kpiReportTemplateDisplayController: CategoryTemplateController = async (
    locationAdminIds,
    categories,
    graphicElement
) => {
    if (!locationAdminIds || !locationAdminIds.filter(d => d != null && d.toString().trim() !== "").length)
        return EMPTY_ARRAY;

    if (!categories || !categories.filter(d => d != null).length) return EMPTY_ARRAY;

    const categoryTermIds = categories.filter(d => d != null && d.tid != null).map(category => category.tid);

    // graphql query charts that have
    // the described categories
    const { query: gql, options } = GET_CATEGORY_CHART_BY_CATEGORY_ID_PARAMS(
        categoryTermIds,
        graphicElement?.kpiReportTemplate?.visGroup
    );

    const categoryCharts =
        options?.skip === true
            ? null
            : await queryEntities<CategoryChartEntity, CategoryChart>(
                  {
                      query: gql,
                      fetchPolicy: options.fetchPolicy as FetchPolicy,
                      variables: options.variables
                  },
                  processors.getCategoryChartFromGQResult
              );

    if (!categoryCharts) return EMPTY_ARRAY;

    // for each chart, execute visibilityFn that will receive these parameters
    // chart data
    // provider
    // the visibilityFn needs to return a boolean
    const visibilities = await Promise.all(
        categoryCharts?.map(categoryChart => {
            return fetchCategoryChartVisibility(null, locationAdminIds, categoryChart);
        }) ?? []
    );

    if (visibilities?.length !== categoryCharts?.length) return EMPTY_ARRAY;

    const visibileCategoryCharts = categoryCharts.filter((__, index) => {
        return visibilities[index] === true;
    });

    // receive true visible charts and receive should-display categories
    const categoryIdToCategoyCharts = _.groupBy(visibileCategoryCharts ?? [], d => d?.category?.tid);
    return categories.filter(d => categoryIdToCategoyCharts?.[d?.tid]).filter(d => d);
};
